(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairExhibitorsByExpoController', VirtualFairExhibitorsByExpoController);

    VirtualFairExhibitorsByExpoController.$inject = ['VirtualFairService', 'SellerService'];


    function VirtualFairExhibitorsByExpoController(VirtualFairService, SellerService) {
        var vm = this;

        vm.expoSelected         = false;
        vm.sellerSelected       = false;
        vm.flag                 = false;
        vm.selectExpo           = selectExpo;
        vm.selectSellers        = selectSellers;
        vm.getByFilter          = getByFilter;

        /*PAGINATION*/
        vm.pageChanged          = pageChanged;
        vm.setPage              = setPage;
        // vm.to                   = null;
        // vm.totalItems           = null;
        // vm.currentPage          = null;
        // vm.itemsPerPage         = null;
        vm.page                 = 1;
        vm.downloadCSV          = downloadCSV;


        function activate() {
            vm.selectExpo();
            vm.selectSellers();
        }

        function selectExpo () {
            VirtualFairService.getAll().then(function(response){
                    vm.expos = response.data;
            }).catch(function(err) {

            });
        }

        function selectSellers () {
            SellerService.getAllVirtualFair().then(function(response){
                vm.sellers = response.data;
            }).catch(function(err) {});
        }

        function getByFilter() {
            vm.flag = false;
            let query = {};
            if (vm.expoSelected) {
                query['virtual_fair_id'] = vm.expoSelected;
            }
            if (vm.sellerSelected) {
                query['seller_id'] = vm.sellerSelected;
            }
            query['page'] = vm.page;
            VirtualFairService.getByFilterExhibitorsByExpo(query).then(function(response){
                vm.flag = true;
                vm.exhibitors = response.data.data;
                vm.totalItems = response.data.total;
                vm.to         = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            }).catch(function(err) {

            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function downloadCSV () {
            let query = {};
            if(vm.expoSelected) {
                query['expo_id'] = vm.expoSelected;
            }
            if(vm.sellerSelected) {
                query['seller_id'] = vm.sellerSelected;
            }
            VirtualFairService.getByFilterExhibitorsByExpoCSV(query).success(function (data) {
              var anchor = document.createElement("a");
              anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
              anchor.target = "_blank";
              anchor.download = `virtual_fair_exhibitors_${vm.expoSelected}.csv`;
              document.body.appendChild(anchor);
              anchor.click();
              $timeout(function () {
                anchor.remove();
              }, 50);
            });
        }

        activate();

    }

})();